import _ from 'lodash'
import React from 'react'
import { CPLAttributes } from '../../common/enums'

import AudioIcon from '../../icons/audio.svg'
import CCIcon from '../../icons/cc.svg'
import CertificateIcon from '../../icons/certification.svg'
import SubTitleIcon from '../../icons/sub.svg'

import CompositionAttributePopOver from './CompositionAtttibutePopOver'

class CompositionAttributes extends React.Component {
  setOrderNumber () {
    const {attributes} = this.props.composition
    return attributes ? attributes.map(
      attribute => _.extend(attribute, {orderNumber: CPLAttributes[attribute.type]}))
      .filter(a => a.orderNumber) : []
  }

  getCompositionAttributes () {
    const {attributes} = this.props.composition

    return _.orderBy(this.setOrderNumber(attributes), ['orderNumber']).map((attribute, idx) => {
      let icon
      let attrClass = 'qw-icon-x-small attr-icon qw-mr-xxx-small'
      switch (attribute.type) {
        case 'language': {
          icon = <AudioIcon className={attrClass}/>
          break
        }
        case 'subtitleLanguage': {
          icon = <SubTitleIcon className={attrClass}/>
          break
        }
        case 'closedCaptions': {
          icon = <CCIcon className={attrClass}/>
          break
        }
        case 'ratings': {
          icon = <CertificateIcon className={attrClass}/>
          break
        }

        default: {
          icon = null
        }
      }
      return this.getCompositionAttribute(idx, attribute.type, attribute.value, icon)
    })
  }

  getCompositionAttribute (idx, type, value, icon) {
    if (!_.isEmpty(_.compact(value))) {
      return <CompositionAttributePopOver key={idx} type={type} value={value} icon={icon}/>
    }
  }

  render () {
    return this.getCompositionAttributes()
  }
}

export default CompositionAttributes



// WEBPACK FOOTER //
// ./src/app/components/compositions/CompositionAttributes.js